<template>
	<div>
		<div v-show="$route.meta.showFather">
			<el-carousel :height="autoHeight" :autoplay="true">
				<el-carousel-item v-for="item in homeData.bannerList" class="banner">
					<img :src="item.bannerImg" alt="" @click="bannerDetails(item)" />
				</el-carousel-item>
			</el-carousel>
			<div class="content">
				<!-- 推荐专家 -->
				<!--  -->
				<div class="is-flex mb-24">
					<div class="is-flex wid-100">
						<img src="../assets/home/zhuanjia.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">推荐专家</p>
							<span>{{info.homeSuggestExpertSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor cursor" @click="moreExpert(1)">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="expert" style="">
					<!-- homeData.expertList.list -->
					<div v-for="(item,index) in homeData.expertList.list" :key="index" class="imgList" style=""
						@click="experDetail(item.id)">
						<img :src="item.avatar" alt="" class="header-img">
						<p class="head-name">{{item.name}}</p>
						<p class="head-school">{{ SString.sstrim(item.company, 16) }}</p>
					</div>
				</div>
				<!-- 公益专家 -->
				<div class="is-flex mt-84 mb-24">
					<div class="is-flex wid-100">
						<img src="../assets/home/gongyi.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">公益专家</p>
							<span>{{info.homeFreeExpertSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreExpert(2)">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="expert" style="">
					<div v-for="(item,index) in homeData.freeExpertList.list" :key="index" class="imgList"
						@click="experDetail(item.id)">
						<img :src="item.avatar" alt="" class="header-img">
						<p class="head-name">{{item.name}}</p>
						<p class="head-school">{{ SString.sstrim(item.company, 16) }}</p>
					</div>
				</div>
				<!-- 大学教授 -->
				<div class="is-flex mt-84 mb-24" style=" ">
					<div class="is-flex wid-100">

						<img src="../assets/home/jiaoshou.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">大学教授</p>
							<span>{{info.homeUniversityProfessorSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreExpert(3)">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="expert" style="">
					<div v-for="(item,index) in homeData.bigExpertList.list" :key="index" class="imgList"
						@click="experDetail(item.id)">
						<img :src="item.avatar" alt="" class="header-img">
						<p class="head-name">{{item.name}}</p>
						<p class="head-school">{{ SString.sstrim(item.company, 16) }}</p>
					</div>
				</div>
				<!-- 基础名师 -->
				<div class="is-flex mt-84 mb-24" style=" ">
					<div class="is-flex wid-100">
						<img src="../assets/home/mingshi.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">基础教育名师</p>
							<span>{{info.homeFamousTeacherSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreExpert(4)">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="expert" style="">
					<div v-for="(item,index) in homeData.smallExpertList.list" :key="index" class="imgList"
						@click="experDetail(item.id)">
						<img :src="item.avatar" alt="" class="header-img">
						<p class="head-name">{{item.name}}</p>
						<p class="head-school">{{ SString.sstrim(item.company, 16) }}</p>
					</div>
				</div>
				<!-- 培训专区 -->
				<div class="is-flex mt-84 mb-24" style=" ">
					<div class="is-flex wid-100">
						<img src="../assets/home/peixun.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">培训专区</p>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="morePx">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="px-list">
					<div class="activity is-flex">
						<div class="line" v-if="actList.length"></div>
						<div class="is-flex just-bet cursor" v-for="(ite,index) in actList.slice(0, 6)" :key="index"
							@click="pxDetail(ite.id)">
							<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
								<!-- <p class="act-14">[活动]</p> -->
								<p class="act-33">{{ite.title}}</p>
							</div>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div>
				<!-- 近期活动 -->
				<div class="is-flex mt-84 mb-24 mt-100">
					<div class="is-flex wid-100">
						<img src="../assets/home/jinqi.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">近期活动</p>
							<span>{{info.homeActiveSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreHd">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="jinqi">
					<div class="jin-div" v-for="(item,index) in homeData.activityList.list" :key="index"
						@click="hdDetail(item.id)">
						<div class="posi-re">
							<img :src="item.coverImage" alt="" class="jin-img">
							<p class="first"
								:class="item.activityStatus=='1000'?'first-1':item.activityStatus=='2000'?'first-2':'first-3'">
								{{item.activityStatus=='1000'?'待开始':item.activityStatus=='2000'?'进行中':'已结束'}}
							</p>
						</div>
						<div class="qinzi">
							<div class="qinzi-1">
								<div class="qinzi-1-1">
									<p class="qinzi-2">{{item.name}}</p>
									<p class="qinzi-3">
										{{utils.getNowTime(item.startTime)}}-{{utils.getNowTime(item.endTime)}}
									</p>
								</div>
								<div style="width: 77px;">
									<p class="qinzi-4">立即报名</p>
								</div>
							</div>
						</div>
					</div>

				</div>

				<!--  精彩直播-->
				<div class="is-flex mt-84 mb-24 mt-100">
					<div class="is-flex wid-100">
						<img src="../assets/home/zhibo.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">精彩直播</p>
							<span>{{info.homeLiveSlogan}}</span>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreZb">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="jinqi">
					<div class="jin-div" v-for="(item,index) in homeData.livingList.list" :key="index"
						@click="zbDetail(item)">
						<div class="posi-re">
							<img :src="item.coverImg" alt="" class="jin-img">
							<!-- <p class="first">{{item.livingStatus}}</p> -->
							<p class="first"
								:class="item.livingStatus=='1000'?'first-1':item.livingStatus=='2000'?'first-2':'first-3'">
								{{item.livingStatus=='1000'?'待开始':item.livingStatus=='2000'?'进行中':'已结束'}}
							</p>
						</div>
						<div class="qinzi">
							<div class="qinzi-1">
								<div class="qinzi-1-1">
									<p class="qinzi-2">{{item.name}}</p>
									<p class="qinzi-3">
										{{utils.getNowTime(item.startTime)}}-{{utils.getNowTimes(item.endTime)}}
									</p>
								</div>
								<div style="width: 77px;">
									<p class="qinzi-4">{{item.livingStatus=='3000'?'观看回放':'观看直播'}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 名校风采 -->
				<div class="is-flex mt-84 mb-24 mt-100">
					<div class="is-flex wid-100">
						<img src="../assets/home/mingxiao.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">名校风采</p>
						</div>
					</div>
					<div class="is-flex mt-15 cursor" @click="moreMx">
						<p class="more">更多</p>
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
				<!-- <el-carousel :autoplay="false" type="" height="200px"> -->
				<!--   <el-carousel-item v-for="item in 6" :key="item">
                        <h3 class="medium">{{ item }}</h3>

                    </el-carousel-item> -->
				<!-- <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
                           <div class="school-item" v-for="(it,i) in item" :key="i"  @click="mxDetail(it.id)">
							   <img :src="it.icon" alt="">
							   <p style="color: #333333;font-family: font3;text-align: center;">{{it.title}}</p>
						   </div>
                        </div>
                    </div>
                    如果需要分页器
                    <div class="swiper-pagination"></div>
                    <div class="button">
                        <div class="swiper-button-prev">
                        </div>
                        <div class="swiper-button-next">
                        </div>
                    </div>
                </div> -->

				<div class="school-center">
					<el-carousel ref="schoolCarousel" trigger="click" :interval="5000" :height="schoolCarouselHelght"
						arrow="never" indicator-position="none">
						<el-carousel-item v-for="(item,index) in swiperList" :key="index">
							<div class="school-list">
								<div class="school-list-item" v-for="(it,i) in item" :key="i" @click="mxDetail(it.id)">
									<div style="width: 5vw;height: 5vw;margin: auto;">
										<img :src="it.icon" alt="">
									</div>
									<p style="color: #333333;font-family: font3;text-align: center;">{{it.title}}</p>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
					<img src="../../src/assets/home/m-left.png" alt="" class="setPrevImg" @click="setPrev" />
					<img src="../../src/assets/home/m-right.png" alt="" class="setNextImg" @click="setNext" />
				</div>

				<!-- 邀请专家流程 -->
				<div class="is-flex mt-84 mb-24 mt-100">
					<div class="is-flex wid-100">
						<img src="../assets/home/yao.png" alt="">
						<div class="titles is-flex">
							<p class="tit-1">邀请专家流程</p>
						</div>
					</div>
					<!-- <div class="is-flex mt-15 cursor">
                        <p class="more">更多</p>
                        <i class="el-icon-arrow-right"></i>
                    </div> -->
				</div>
				<img :src="homeData.pcExpertImage" alt="" style="width: 100%;height: 100%;">
			</div>
		</div>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
		<footers></footers>

		<div class="advertisement-dialog">
			<el-dialog :visible.sync="advertisementShow" width="800px" :before-close="handleClose">
				<div class="advertisement">
					<img :src="swiperLists.bannerImg" alt="" style="width: 760px;height: 500px;cursor: pointer;"
						@click="clickBanner" />
				</div>
			</el-dialog>
		</div>
	</div>


</template>
<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import footers from '@/views/footers.vue';
	import {
		getHome,
		getSwiperList,
		getInfo,
		getBannerList
	} from '@/api/api.js';
	export default {
		components: {
			footers
		},
		data() {
			return {
				token: '',
				swiperList: [],
				homeData: {
					bannerList: [],
					activityList: {
						list: []
					},
					bigExpertList: {
						list: []
					},
					expertImage: '',
					pcExpertImage: '',
					expertList: {
						list: []
					},
					freeExpertList: {
						list: []
					},
					livingList: {
						list: []
					},
					smallExpertList: {
						list: []
					},

				},
				actList: [],
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				info: {
					homeSuggestExpertSlogan: '',
					homeFreeExpertSlogan: '',
					homeUniversityProfessorSlogan: '',
					homeFamousTeacherSlogan: '',
					homeActiveSlogan: '',
					homeLiveSlogan: '',
				},
				advertisementShow: false,
				swiperLists: {
					bannerImg: '',
				},
				autoHeight: '526px',
				schoolCarouselHelght: '180px',
			}
		},
		// watch: {
		//    '$route'() {
		//      // 若路由产生变换（退出或提交成功切换回上一页时），将页面数据重置为初始值
		//      Object.assign(this.$data, this.$options.data())
		//      // 此处别忘了加上created里需要执行的请求，因为在keep-alive的单页面中切换路由不会执行created钩子
		//    }
		//  },
		mounted() {
			//localStorage.setItem('keyToken', 'bcdf53db06d14038b9ab6057e7476097');
			switch (window.performance.navigation.type) {
				case 0:
					localStorage.setItem('advertisementShow', '')
					this.getSwipers();
					break;
				case 1:
					this.getSwipers();
					console.log("页面刷新完了");
					break;
			}
			this.autoHeight = window.innerWidth / 3.65 + 'px';
			window.onresize = () => {
				return (() => {
					this.autoHeight = window.innerWidth / 3.65 + 'px';
				})()
			}
			window.addEventListener("unload", (e) => this.unloadHandler(e));
			this.token = localStorage.getItem('keyToken');
			this.getSwiper();
			this.getFeng();
			this.getInit();
			this.getInfos();
		},
		methods: {
			unloadHandler() {
				localStorage.setItem('advertisementShow', '');
			},
			clickBanner() {
				if (this.swiperLists.content) {
					window.open(this.swiperLists.content, '_blank')
				}
			},
			handleClose() {
				this.advertisementShow = false;
				localStorage.setItem('advertisementShow', true);
			},
			getSwipers() {
				let params = {
					bannerType: 3,
					status: 1,
					adType: 1,
				}
				getBannerList(params).then(res => {
						if (res.data.list.length > 0) {
							this.swiperLists = res.data.list[0];
							let advertisementShow = localStorage.getItem('advertisementShow');
							if (res.data.list.length > 0 && !advertisementShow) {
								this.advertisementShow = true;
							}
						}
					})
					.catch(error => {

					});
			},
			setNext() {
				this.$refs.schoolCarousel.next();
			},
			setPrev() {
				this.$refs.schoolCarousel.prev();
			},
			bannerDetails(item) {
				if (item.linkType==0) {
					return;
				}
				if (item.linkType==1) {
					this.$router.push({
						name: 'bannerDetails',
						params: {
							id: item.id,
							// footersType: 1,
						}
					})
				}
				if (item.linkType==2) {
					window.open(item.link, '_blank');
				}
			},
			Lunbo() {
				var swiper = new Swiper('.swiper-container', {
					pagination: { // 如果需要分页器
						el: '.swiper-pagination',
						type: 'bullets', // 分页器样式类型，默认bullets圆点 fraction分式，progressbar进度条，custom自定义
						// renderBullet: function(index, className) {
						//     console.log('index:', index)
						//     console.log('className:', className)
						//     return '<span class="' + className + '">' + (index + 1) + '</span>'
						// }
					},
					mousewheel: false, // 是否开启鼠标滚轮控制swiper切换 ，默认false
					direction: 'horizontal', // 滑动方向
					// speed: 500, // 切换速度，自动滑动开始到结束的时间
					grabCursor: true, // 悬浮时鼠标样式切换
					slidesPerView: 6, // slider容器能够同时显示的slides数量，默认为1，auto自动根据slide宽度来设定数量
					slidesPerGroup: 1, // 定义多少slide为一组，默认为1
					spaceBetween: 10, // slide之间的距离
					centerInsufficientSlides: false, // 当slide总数小于slidesPerView时，slide居中
					effect: 'slide', // slide的切换效果，默认为'slide'位移切换，'fade'淡入，'cube'方块，'coverflow'3d流，'flip'3d翻转，'cards'卡片式，'creative'创意性
					navigation: { // 如果需要前进后退按钮
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					loop: false // 循环模式选项
				});
			},
			getInfos() {
				getInfo().then(res => {
						this.info = res.data;
					})
					.catch(error => {});
			},
			getInit() {
				let params = {
					type: 1
				}
				getHome(params).then(res => {
						this.homeData = res.data;
					})
					.catch(error => {});
			},
			getSwiper() {
				let params = {
					type: 1,
					pageNo: 1,
					pageSize: this.pageGroup.size
				}
				getSwiperList(params).then(res => {
						this.swiperList = this.getNewArr(res.data.list, 7);
						this.Lunbo();
					})
					.catch(error => {

					});
			},
			getNewArr(arr, n) {
				let newArr = [];
				for (let i = 0; i < arr.length; i += n) {
					newArr.push(arr.slice(i, i + n))
				}
				return newArr;
			},
			getFeng() {
				let params = {
					type: 2,
					pageNo: 1,
					pageSize: this.pageGroup.size
				}
				getSwiperList(params).then(res => {
						this.actList = res.data.list;
						console.log(this.actList, 'this.actList')
					})
					.catch(error => {

					});
			},
			reloadPage() {
				this.$router.go(0); // 重新加载当前页面
			},
			moreExpert(type) {
				this.$router.push({
					name: 'wisdom',
					params: {
						type: type,
						// footersType: 1,
					}
				})
				// this.$router.push('/expert/wisdom')
			},
			morePx() {
				this.$router.push({
					path: '/training/zone',
					query: {
						// footersType: 1,
					}
				})
			},
			moreHd() {
				this.$router.push({
					path: '/activity/index',
					query: {
						// footersType: 1,
					}
				})
			},
			moreMx() {
				this.$router.push({
					path: '/famous/school',
					query: {
						// footersType: 1,
					}
				})
			},
			moreZb() {
				this.$router.push({
					path: '/broadcast/index',
					query: {
						// footersType: 1,
					}
				})
			},
			experDetail(id) {
				this.$router.push({
					name: 'expertDetail',
					params: {
						id: id,
						// footersType: 1,
					}
				})
				// this.$route.fullPath子传父 给homeview
				// this.$router.push('/expert/expertDetail')
			},
			pxDetail(id) {
				this.$router.push({
					name: 'detail',
					params: {
						id: id,
						// footersType: 1,
					}
				})
			},
			hdDetail(id) {
				this.$router.push({
					name: 'activityDetail',
					params: {
						id: id,
						// footersType: 1,
					}
				})
			},
			zbDetail(item) {
				window.open(item.linkUrl);
			},
			mxDetail(id) {
				this.$router.push({
					name: 'schoolDetail',
					params: {
						id: id,
						// footersType: 1,
					}
				})
				// this.$router.push('/famous/schoolDetail')
			},

		}
	}
</script>

<style scoped>
	.banner img {
		width: 100%;
		height: 100%;
	}

	.font1 {
		font-family: font1;
	}

	.content {
		margin-top: 32px;
		padding: 0 19%;
	}

	.is-flex {
		display: flex;
		align-items: center;
	}

	.is-flex img {
		width: 35px;
		height: 35px;
	}

	.titles {
		position: absolute;
		left: 8px;
		top: 12px;
	}

	.tit-1 {
		font-family: font5;
		font-size: 20px;
		color: #222222;
		margin-right: 8px;
	}

	.titles span {
		font-family: font3;
		font-size: 14px;
		color: #999999;
	}

	.el-icon-arrow-right:before {
		color: #666666;
		width: 14px;
		height: 14px;
	}

	.more {
		width: 28px;
		font-size: 14px;
		font-family: font3;
		color: #333333;
		margin-right: 8px;
	}

	.header-img {
		width: 9vw;
		height: 9vw;
		/* width: 186px;
        height: 186px; */
		/* width: 11.625rem; */
		/* width: 100%; */
		/* height: auto; */
		/* display: block; */
		/* object-fit: cover; */
		/*      min-width: 11.625rem;
            min-height: 11.625rem;
            max-height: 11.625rem;
            max-width: 11.625rem; */
		/* width: 11.625rem; */
		/* max-height: 11.625rem; */
		/* margin: auto; */
		border-radius: 8px;

		/* margin: 0 auto; */
	}

	.head-name {
		/* width: 186px; */
		/* width: 9vw; */
		font-size: 18px;
		font-family: font5;
		color: #222222;
		text-align: center;
		margin: 16px 0 8px 0;
		font-weight: normal;
		/* overflow: hidden; */
	}

	.head-school {
		padding: 0 8px 8px 8px;
		height: 42px;
		line-height: 21px;
		font-size: 14px;
		font-family: font3;
		color: #999999;
		/* margin-bottom: 53px; */
		text-align: center;
		font-weight: normal;
	}

	.expert {
		/* border: 1px solid; */
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
		flex-direction: row;
	}

	.expert>.imgList:last-child:nth-child(6n - 4) {
		margin-right: 42vw;
	}

	.expert>.imgList:last-child:nth-child(6n - 3) {
		margin-right: 32vw;
	}

	.expert>.imgList:last-child:nth-child(6n - 2) {
		margin-right: 21vw;
	}

	.expert>.imgList:last-child:nth-child(6n - 1) {
		margin-right: 9vw;
	}

	.imgList {
		/* width: 11.625rem; */
		/* height: 17.9375rem;
        margin-right: 1rem; */
		/* width: 15.2%; */
		/* width: 11.625rem; */
		width: 9vw;
		/* margin-bottom: 1.5rem; */
		cursor: pointer;
		/* margin: 0 0.4rem; */
		overflow: hidden;
		/* 隐藏超出容器大小的部分内容 */

	}

	.mt-84 {
		margin-top: 76px;
	}

	.px-list {
		/* min-height: 168px; */
		/* height: 168px; */
		background: #FFFFFF;
		box-shadow: 0px 4px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		margin-top: 24px;
		padding: 24px;
	}

	.activity {
		position: relative;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.line {
		position: absolute;
		width: 0px;
		height: 90%;
		opacity: 1;
		border: 1px solid #EFEFEF;
		left: 50%;
	}

	.just-bet {
		justify-content: space-between;
		width: 48%;
		height: 40px;
		/* line-height: 40px; */
	}

	.just-bet .act-33 {
		/* width: 491px; */
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #666666;
		font-family: font3;
		overflow: hidden;
		/* white-space: nowrap; */
		text-overflow: ellipsis;
	}

	.just-bet .act-14 {
		font-size: 14px;
		color: #333333;
		font-weight: 600;
		margin-right: 3px;
		white-space: nowrap;
	}

	.mingxio img {
		display: block;
		margin: 0;
		width: 100%;
		height: auto;
	}

	.mingxio {
		justify-content: space-between;
	}

	.mingxio p {
		font-size: 14px;
		font-family: font3;
		color: #333333;
		text-align: center;
		margin-top: 15%;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.wid-100 {
		position: relative;
		width: 100%;
	}

	.mt-15 {
		margin-top: 15px;
	}

	.mt-100 {
		margin-top: 100px;
	}

	.jinqi {
		margin-top: 28px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.jinqi>.jin-div:last-child:nth-child(4n - 2) {
		margin-right: 31vw;
	}

	.jinqi>.jin-div:last-child:nth-child(4n - 1) {
		margin-right: 15vw;
	}

	.posi-re {
		position: relative;
		width: 100%;
	}

	.jin-img {
		width: 100%;
		height: auto;
		/* max-height: 10rem;
        min-height: 10rem; */
		/* height: 10rem !important; */
		object-fit: cover;
		/* width: 100%;
        height: auto; */
		display: block;
		border-radius: 8px 8px 0 0;
	}

	.first {
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
		/* line-height: 21px; */
		position: absolute;
		left: 0;
		top: 0;
		border-radius: 4px 16px 4px 16px;
		padding: 4px 16px;
	}

	.first-1 {
		color: #FBB54C;
		background: #FFF6F0;
	}

	.first-2 {
		color: #3ECC64;
		background: #EBFAEF;
	}

	.first-3 {
		color: #FF534D;
		background: #FFF0F0;
	}

	.qinzi {
		width: 100%;
		background: #FFFFFF;
		box-shadow: 0px 4px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		/* width: 288px; */
		/* height: 72px; */
	}

	.qinzi-1 {
		width: 90%;
		padding: 10px 5%;
		/* padding: 10px 9px 8px 10px; */
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.qinzi-1-1 {
		width: 60%;
	}

	@media (max-width: 1300px) {
		.qinzi-1-1 {
			width: 30%;
		}
	}

	.qinzi-2 {
		font-size: 16px;
		font-family: font5;
		color: #222222;
		margin-bottom: 8px;
		/* width: 90%; */
		overflow: hidden;
		/* white-space: nowrap; */
		text-overflow: ellipsis;
		display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
	}

	.qinzi-3 {
		font-family: font3;
		font-size: 10px;
		color: #222222;
		/* width: 90%; */
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.qinzi-4 {
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-family: font3;
		color: #fff;
		padding: 0.25rem 0.625rem;
		background: #3377FF;
		border-radius: 0.25rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.jin-div {
		width: 23%;
		/* margin-right: 23px; */
	}

	.imgList:hover {
		transform: scale(1.1);
		/* 鼠标悬停时放大到1.5倍 */
		transform-origin: center;
		box-shadow: 0px 4px 16px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		background: #FFFFFF;
		/* width: 17.5%;
        background: #FFFFFF;
        box-shadow: 0px 4px 16px 0px rgba(195,219,255,0.25);
        border-radius: 8px 8px 8px 8px;
        margin-bottom: 1.5rem;
        cursor: pointer; */
	}

	/* 分辨率为1600*1200时 */
	@media (max-width: 1600px) {
		.imgList {
			/* width: 15%;
            height: auto;
            margin-right: 1rem */
		}

		.header-img {
			/* width: 100%;
            height: auto; */
			/*  width: 11.625rem;
            height: 11.625rem; */
		}

		.head-name {
			font-size: 17px;
		}

		.head-school {
			font-size: 13px;
		}

		.first {
			font-size: 13px;
			border-radius: 2px 8px 2px 8px;
			padding: 4px 8px;
		}

		.qinzi-2 {
			font-size: 15px;
		}

		.qinzi-3 {
			font-size: 13px;
		}

		/* .qinzi-4 {
			font-size: 13px;
			padding: 3px 6px;
		} */

		.mingxio img {
			transform: scale(0.9);
		}

		.mingxio p {
			font-size: 13px;
		}

		.tit-1 {
			font-size: 19px;
		}

		.titles span {
			font-size: 13px;
		}
	}

	.swiper-wrapper img {
		width: 100px;
		height: 100px;
		margin-bottom: 10px;
		border-radius: 50%;
	}


	.swiper-container {
		--swiper-theme-color: #1890FF;
		/* 设置Swiper风格 */
		--swiper-pagination-color: #00ff33;
		/* 单独设置分页导航颜色 */
		margin: 0 auto;
	}

	.swiper-wrapper {
		width: 100%;
		/* border: 1px solid; */
		transition-timing-function: linear;
		-webkit-transition-timing-function: linear;

	}

	.swiper-slide {
		/* // background: url(~@/assets/images/default.png) no-repeat center; */
		/* background-color: #000; */
		background-size: cover;
		display: flex;
		align-items: center;
		padding: 0 50px;
	}

	.school-item {
		margin: 0 29px;
	}

	.school-center {
		height: 140px;
		position: relative;
	}

	.school-list {
		width: 90%;
		display: flex;
		/* align-items: center; */
		margin: auto;
	}

	.setPrevImg {
		width: 24px;
		height: 24px;
		position: absolute;
		left: 0px;
		top: 50%;
		z-index: 999999;
		transform: translateY(-50%);
	}

	.setNextImg {
		width: 24px;
		height: 24px;
		position: absolute;
		right: 0px;
		top: 50%;
		z-index: 999999;
		transform: translateY(-50%);
	}


	.school-list-item {
		width: 12%;
		/* height: 140px; */
		margin: 0 20px;
	}

	.school-list-item img {
		width: 100%;
		/* height: 90px; */
		/* height: 80%; */
	}

	.school-list-item p {
		font-size: 14px;
		font-weight: normal;
		color: #333333;
		margin-top: 16px;
	}

	.swiper-lazy {
		width: 100%;
		height: 100%;
		background-size: cover;
	}

	.swiper-pagination :deep(.swiper-pagination-bullet-active) {
		color: #fff;
		background: #007aff;
	}

	.swiper-pagination :deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	/deep/.swiper-button-next {
		right: 0;
		/* background: url("../assets/expert/close-1.png"); */
	}

	/deep/.swiper-button-prev {
		left: 0;
	}

	.advertisement {
		width: 760px;
		height: 500px;
		text-align: center;
		position: relative;

		img {
			position: absolute;
			top: 0;
			left: 0;
		}
	}
</style>